export default __webpack_public_path__ + "static/media/Foursquare.9fe69de7.svg";